import ar from './ar.json';
import da from './da.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fi from './fi.json';
import fr from './fr.json';
import ja from './ja.json';
import kn from './kn.json';
import nl from './nl.json';
import ptBr from './pt-br.json';
import tr from './tr.json';

export default {
  ar: { translation: ar },
  da: { translation: da },
  de: { translation: de },
  en: { translation: en },
  es: { translation: es },
  fi: { translation: fi },
  fr: { translation: fr },
  ja: { translation: ja },
  kn: { translation: kn },
  nl: { translation: nl },
  ptBr: { translation: ptBr },
  tr: { translation: tr },
};
